import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const bondInitialValues = {
  name: "",
  description: "",
  price: "1",
  currency: "EUR",
  session: "",
  daysCaducity: "",
  maxSession: "",
  name_group_bond: "",
  groupBondId: null,
  checkedBonos: false,
  has_access_general: false,
  checkedAcumular: false,
  groupBond: "",
};

export const bondValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  description: Yup.string().optional(),
  price: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),

  session: Yup.number().when(
    "checkedBonos",
    (checkedBonosValue: any, schema: Yup.NumberSchema) => {
      return checkedBonosValue === false
        ? schema.required(FIELD_REQUIRED_MESSAGE)
        : schema.optional();
    }
  ),

  daysCaducity: Yup.number().optional(),

  maxSession: Yup.number().when(
    "checkedAcumular",
    (checkedAcumularValue: any, schema: Yup.NumberSchema) => {
      return checkedAcumularValue === true
        ? schema.required(FIELD_REQUIRED_MESSAGE)
        : schema.optional();
    }
  ),

  groupBond: Yup.string().optional(),
  name_group_bond: Yup.string().optional(),

  groupBondId: Yup.number()
    .nullable()
    .when("name_group_bond", {
      is: (val: string | null | undefined) => !val || val.trim() === "",
      then: (schema) => schema.required(FIELD_REQUIRED_MESSAGE),
      otherwise: (schema) => schema.optional(),
    }),

  checkedBonos: Yup.boolean().optional(),
  has_access_general: Yup.boolean().optional(),
  checkedAcumular: Yup.boolean().optional(),
});

export type CreateBondValues = typeof bondInitialValues;
